import { AnalysisSelections } from "../@types";

import { DYNAMIC_ANALYSIS_OPTIONS } from "./consts";

export const getDynamicAnalysisList = (
  values: AnalysisSelections
): string[] => {
  if (values.local_only) {
    return [];
  }

  return Object.entries(values)
    .filter(([key]) => DYNAMIC_ANALYSIS_OPTIONS.includes(key))
    .filter(([, value]) => value)
    .map(([key]) => key);
};

export const getObjectValue = <T, K extends keyof T>(
  obj: T,
  key: K,
  active: boolean
): T[K] | undefined => {
  if (!active) return undefined;
  return obj[key];
};

export const filterNonLocalAnalyses = (
  analyses: AnalysisSelections
): AnalysisSelections =>
  Object.entries(analyses).reduce<AnalysisSelections>((acc, [key, value]) => {
    acc[key as keyof AnalysisSelections] = key === "tc" ? value : false;
    return acc;
  }, {} as AnalysisSelections);
